import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

//mode は。plan to order があり一旦、plan または orderの場合は access_type=authorizerをつけることとする
//mode は　"", "plan_key" , "print_order_id" の3種類とする
const modePlanKey = "plan_key";
const modePrintOrderId = "print_order_id";
const modeOrderKey = "order_key";
const modeGeeniePlanKey = "geenie_plan_key"
const modeGeenieOrderKey = "geenie_order_key"
const modeTicketPlanKey = "ticket_plan_key"
const mapModeStore = new Vuex.Store({
  state: {
    mode: "",
    planKey: "",
    printOrderId: "",
    modeOkikomi: "",
    planKeyOrikomi: "",
    orderKeyOrikomi: "",
    groupId: "",
    planKeyGeenie: "",
    orderKeyGeenie: "",
    groupIdGeenie: "",
    planKeyTicket: "",
  
  },
  mutations: {
    updateMode(state, mode) {
      state.mode = mode;
    },
    updateModeOrikomi(state, modeOrikomi) {
      state.modeOkikomi = modeOrikomi;
    },
    updatePlanKey(state, planKey) {
      state.mode = modePlanKey;
      state.planKey = planKey;
    },
    updateGroupId(state, groupId) {
      state.groupId = groupId;
    },
    updateTicketPlan(state, planKey) {
      state.mode = modeTicketPlanKey;
      state.planKeyTicket = planKey;
    },
    updateGroupIdGeenie(state, groupId) {
      state.groupIdGeenie = groupId;
    },
    updatePlanKeyOrikomi(state, planKeyOrikomi) {
      console.log(modePlanKey, planKeyOrikomi);
      state.modeOrikomi = modePlanKey;
      state.planKeyOrikomi = planKeyOrikomi;
    },
    updatePrintOrderId(state, printOrderId) {
      state.mode = modePrintOrderId;
      state.printOrderId = printOrderId;
    },
    updateOrderKeyOrikomi(state, orderKeyOrikomi) {
      state.modeOrikomi = modeOrderKey;
      state.orderKeyOrikomi = orderKeyOrikomi;
    },
    updatePlanKeyGeenie(state, planKeyGeenie) {
      state.mode = modeGeeniePlanKey
      state.planKeyGeenie = planKeyGeenie
    },
    updateOrderKeyGeenie(state, orderKeyGeenie) {
      state.mode = modeGeenieOrderKey
      state.orderKeyGeenie = orderKeyGeenie
    },
    clearMode(state) {
      state.mode = "";
      state.planKey = "";
      state.printOrderId = "";
      state.modeOrikomi = "";
      state.planKeyOrikomi = "";
      state.orderKeyOrikomi = "";
      state.groupId = "";
    },
  },
  getters: {
    mode(state) {
      return state.mode;
    },
    mapUrlOption(state) {
      // alert("mode==" + state.mode)
      console.log(state.mode, "hagsashjgashjg")
      if (state.mode == modePlanKey) {
        return `&plan_key=${state.planKey}&group_id=${state.groupId}&access_type=authorizer`;
      } else if (state.mode == modePrintOrderId) {
        return (
          "&print_order_id=" + state.printOrderId + "&access_type=authorizer"
        );
      } else if (state.mode == modeGeeniePlanKey) {
        return `&geenie_plan_key=${state.planKeyGeenie}&geenie_group_id=${state.groupIdGeenie}&access_type=authorizer`
      } else if (state.mode == modeGeenieOrderKey) {
        return `&geenie_order_key=${state.orderKeyGeenie}&access_type=authorizer`
      } else if (state.mode == modeTicketPlanKey) {
        return `&ticket_plan_key=${state.planKeyTicket}&access_type=authorizer`
      }
      else {
        return "";
      }
    },
    mapUrlOptionOrikomi(state) {
      if (state.modeOrikomi == modePlanKey) {
        return "&plan_key=" + state.planKeyOrikomi;
      } else if (state.modeOrikomi == modeOrderKey) {
        return "&order_key=" + state.orderKeyOrikomi;
      } else {
        return "";
      }
    },
  },
  plugins: [createPersistedState()],
});

export { mapModeStore, modePlanKey, modeOrderKey, modePrintOrderId };
